module.exports = __webpack_public_path__ + "static/media/pt10.85155abe.png";